import filiar  from '../../../../Assets/help-page/filiar_templo.mp4'
import chatUsuario from '../../../../Assets/help-page/chat_usuário_comum.mp4'

export const CarouselData = [
  {
    video:
      filiar 
  },
  {
    video:
      chatUsuario
  },
];